import { z } from 'zod'

export const ZendeskSchemas = {
  sessionPageId: {
    request: z.object({
      page_id: z.string(),
    }),
    query: z.undefined(),
    response: z.undefined(),
    path: z.undefined(),
  },
}
